import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../../components/AppAnimate";
import AppCard from "../../../../components/layouts/components/AppCard";
import ManageTransferPricing from "./ManageTransferPricing";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import {shopTypesWithName} from "../../../../../config/Permissions";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import TextField from "@material-ui/core/TextField";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import {currencySymbol} from "../../../../../config/values";
import {withRouter} from "react-router-dom";
import {connect} from "trim-redux";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import Alert from "@material-ui/lab/Alert/Alert";
import LoadingButton from "../../../../components/elements/LoadingButton";
import validator from "validator";
import {checkMelliCode, updateRedux} from "../../../../../config/Security";
import Typography from "@material-ui/core/Typography/Typography";


class TransferPricingPage extends React.Component {
    classes = this.props.classes;

    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.manageTransferPricing}>
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12}>
                        <AppCard>
                            <Grid container spaicng={2} justifyContent="center">
                                <Grid item xs={12} lg={11}>
                                    <ManageTransferPricing/>
                                </Grid>
                            </Grid>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,

});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(TransferPricingPage))));
